import React from 'react';
import LessonHome from '../LessonHome';

const Lesson15 = (props) => {

    return ( 
        <LessonHome
            {...props}
        />        
     );
}
 
export default Lesson15;